import SatCheckBox from '@components/common/satUI/SatCheckBox';
import { setSkipVerifyYn } from '@store/actions/planAction';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

const SkipVerifyCheckbox = () => {
  const dispatch = useDispatch();
  const { skipVerifyYn } = useSelector(state => state.planReducer);
  const isSkipVerifyYn = skipVerifyYn === 'Y';

  const handleChangeSkipVerifyYn = isChecked => {
    dispatch(setSkipVerifyYn(isChecked ? 'Y' : 'N'));
  };

  return (
    <div className="box-item-Tooltip">
      <SatCheckBox
        value={[isSkipVerifyYn]}
        options={[{ label: '전산심사제외 (개발기능)', value: isSkipVerifyYn }]}
        onChange={handleChangeSkipVerifyYn}
      />
    </div>
  );
};

export default SkipVerifyCheckbox;
